"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDefaultColumnFilterPredicate = void 0;
const getDefaultColumnFilterPredicate = (column, defaultColumnFilter) => {
    return typeof defaultColumnFilter === 'function'
        ? defaultColumnFilter(column)
        : defaultColumnFilter;
};
exports.getDefaultColumnFilterPredicate = getDefaultColumnFilterPredicate;
